import React from 'react';

import ReactDOM from 'react-dom';

import { AuthProvider } from 'utils/hooks/providers/auth-context';

import './index.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    runtimeConfigs?: any;
  }
}

ReactDOM.render(
  <AuthProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </AuthProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
